import Hotjar from '@hotjar/browser';
import { getConfig } from '../utils/config';

const siteId = Number(getConfig().hotjarId);
const hotjarVersion = 6;

export const HotjarService = {
  init: () => {
    if (import.meta.env.DEV) {
      console.log('[Hotjar] init skipped in dev mode!');
      return;
    }
    console.log('[Hotjar] init service');
    Hotjar.init(siteId, hotjarVersion);
  },
};
